export const GoogleBannedCharacters = ["{", "}", "[", "]", "(", ")", "€", "£", "™®"];
